import { CALL_API } from 'redux-api-middleware'

export const TOPIC_FOLLOW_REQUEST = 'TOPIC_FOLLOW_REQUEST'
export const TOPIC_FOLLOW_SUCCESS = 'TOPIC_FOLLOW_SUCCESS'
export const TOPIC_FOLLOW_FAILURE = 'TOPIC_FOLLOW_FAILURE'

export function followTopic(href, slug, previousCount) {
  const meta = { slug, wantFollowing: true, previousCount }
  return {
    [CALL_API]: {
      endpoint: href,
      method: 'POST',
      types: [
        { type: TOPIC_FOLLOW_REQUEST, payload: meta, meta },
        { type: TOPIC_FOLLOW_SUCCESS, meta },
        { type: TOPIC_FOLLOW_FAILURE, meta },
      ],
    },
  }
}

export function unfollowTopic(href, slug, previousCount) {
  const meta = { slug, wantFollowing: false, previousCount }
  return {
    [CALL_API]: {
      endpoint: href,
      method: 'DELETE',
      types: [
        { type: TOPIC_FOLLOW_REQUEST, payload: meta, meta },
        { type: TOPIC_FOLLOW_SUCCESS, meta },
        { type: TOPIC_FOLLOW_FAILURE, meta },
      ],
    },
  }
}
